// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".column.is-6[data-v-45c9fe76] {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
